import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { IVehicleResult } from '../../types.d';
import { IVehicle } from '../../features/vehicle/types';
import { actionTypes as vehicleActionTypes } from '../../features/vehicle'
import { 
  getVehicleTitle, 
  getVehicleDescriptionLine, 
  getVehicleDescriptionSecondaryLine, 
  getVehicleDescriptionTertiaryLine 
} from '../../helpers'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.scss';

SwiperCore.use([Navigation]);

interface SelectVehicleValues 
{
  vehicles: IVehicleResult[] | IVehicle[],
  onSelect: Function, 
  onClear: Function
}
const SelectVehicle: React.FC<SelectVehicleValues> = ({ vehicles, onSelect, onClear }) => {
  const dispatch = useDispatch();
  const breakpoints = {
    // when window width is >= 
    320: {
      slidesPerView: 1
    },
    600: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    },
    1268: {
      slidesPerView: 4
    }
  };
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const onBeforeSwiperInit = (Swiper: SwiperCore): void => {
    if (typeof Swiper.params.navigation !== 'boolean' && Swiper.params.navigation){
      Swiper.params.navigation.prevEl = navigationPrevRef.current;
      Swiper.params.navigation.nextEl = navigationNextRef.current;
    }
  };
  const handleVehicleSelect = (v: IVehicleResult) => {
    dispatch({ type: vehicleActionTypes.SET_VEHICLE, payload: v });
    onSelect();
  };
  const handleChangeClick = () => {
    onClear();
  };
  const [isInit, setIsInit] = useState<Boolean>(false);
  const [showButtons, setShowButtons] = useState<Boolean>(false);
  const getButtonVisibility = (): Boolean => {
    const b = Object.keys(breakpoints).map(o => parseInt(o));
    let show = false;
    for (let i = 0; i != b.length; ++i){
      if (b[i] > window.innerWidth || i+1 === b.length){
        show = (breakpoints as any)[b[i]].slidesPerView <= vehicles.length;
        break;
      }
    }
    return show;
  }
  useEffect(() => {
    if (!isInit){
      setIsInit(true);
      setShowButtons(getButtonVisibility());
      let timer: any = null;
      const resizeListener = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          setShowButtons(getButtonVisibility());
        }, 500);
      };
      window.addEventListener('resize', resizeListener);
    }
  })
  // handleResize();
  return (
    <Fragment>
      <section className="i-step-found-match">
        <div className="i-con">
          <h2>We’ve found a match! Please select your&nbsp;car</h2>
          <p className="i-select-vehicle-disclaimer">Car colours are indicative only</p>
        </div>
        <div className="i-swiper-wrapper">
          <div className="i-con">
            <div className="i-swiper-holder">
              <Swiper className="i-vehicle-list"
                watchSlidesVisibility
                spaceBetween={0}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
                slidesPerView={1}
                breakpoints={breakpoints}
                onBeforeInit={onBeforeSwiperInit}
                navigation={vehicles.length > 1 ? {
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current,
                } : false}
              >
                {vehicles.map((v: IVehicleResult, i: number) => {
                  return (<SwiperSlide key={i}>{ ({ isVisible }) =>
                    <div className="i-vehicle-item" aria-hidden={!isVisible}>
                      <h5>{getVehicleTitle(v)}</h5>
                      {/* level="3" */}
                      <img src={v.imageUrl ? v.imageUrl : `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 660 495"><g transform="translate(0,198)" /></svg>`} alt={getVehicleTitle(v)} />
                      <p><strong>{getVehicleDescriptionLine(v)}</strong></p>
                      <p>
                        {getVehicleDescriptionSecondaryLine(v)} &nbsp;
                        {getVehicleDescriptionTertiaryLine(v)}
                      </p>
                      <div className="i-button-group">
                        <button className="button-outline" tabIndex={isVisible ? 0 : -1} onClick={() => handleVehicleSelect(v)}>This is my vehicle</button>
                      </div>
                    </div>
                  }</SwiperSlide>)
                } )}
              </Swiper>
            </div>
            <div className="i-button-group">
              {showButtons ? <Fragment>
                <button ref={navigationPrevRef} className="swiper-button-prev" aria-label="Previous car"></button>
                <button ref={navigationNextRef} className="swiper-button-next" aria-label="Next car"></button>
              </Fragment>: ''}
              <button className="button-text" onClick={handleChangeClick}>This isn’t my car, change&nbsp;rego</button>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  )
}

export default SelectVehicle
